import { render, staticRenderFns } from "./CancelledAppointments.vue?vue&type=template&id=619db7d6&scoped=true"
import script from "./CancelledAppointments.vue?vue&type=script&lang=js"
export * from "./CancelledAppointments.vue?vue&type=script&lang=js"
import style0 from "./CancelledAppointments.vue?vue&type=style&index=0&id=619db7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619db7d6",
  null
  
)

export default component.exports